import React, { useState } from 'react';
import styles from './nav-row.module.scss';
import SearchForm from './search-form';
import Menu from './menu';


function TopRow() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  return (
    <div className={styles.navRow}>
      <div className="align-items-center d-lg-none d-flex pb-lg-0 pb-3">
        <div className="ms-2">
          <button className="navbar-toggler text-white" onClick={() => setMenuOpen(!menuOpen)} type="button" aria-label="باز/بسته منو">
            <i className="fa fa-bars" />
          </button>
        </div>
        <div className="w-100">
          <SearchForm />
        </div>
      </div>
      <Menu open={menuOpen} setMenuOpen={setMenuOpen} />
    </div>
  );
}

export default TopRow;